<template>
	<Loader v-if="loading" />
	<div v-else class="content">
		<h1>Email templates</h1>
		<div class="margin-top">

			<Modal v-if="edit_template" v-on:close="edit_template = false;">

				<div class="margin-bottom">
					<MaterialText v-model="edit_template.subject" label="Subject" class="long" />
				</div>

				<textarea ref="textarea" v-model="edit_template.message" rows="15" cols="70"></textarea>

				<div style="max-height: 300px; overflow-y: scroll;">
					<div class="margin-top small-margin-bottom">
						<strong>Variables you can use in this template</strong>
					</div>
					<div>
						<div v-for="variable in getVariabeNames">
							<div>
								{{ variable.name }} <span style="color: #aaa">(Class: {{ variable.class }})</span>
							</div>
							<div v-for="key in variable.keys" v-on:click="insertKey(variable.name, key)" style="cursor: pointer;">
								{{ variable.name }}.{{ key }}
							</div>
						</div>
					</div>
				</div>

				<div class="margin-top">
					<table style="width: 100%">
						<thead>
							<tr>
								<th>Variable</th>
								<th>Class</th>
								<th>ID</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="variable in getVariables">
								<td>
									{{ variable.variable }}
								</td>
								<td>
									{{ variable.class }}
									<!-- <input type="text" style="width: 280px" v-model="variable.class" /> -->
								</td>
								<td>
									<input type="number" style="width: 100px" v-model="example_ids[variable.variable]" />
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div class="margin-top">
					<button :disabled="saving" v-on:click="update()" class="small-margin-right">Save</button>
					<button :disabled="saving" v-on:click="sendExampleToMe()">Send example to me</button>
				</div>

			</Modal>

			<table>
				<thead>
					<tr>
						<th>Identifier</th>
						<th v-for="locale in getLocales">
							<Flag :localeid="locale.id" />
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(templates, identifier) in records">
						<td>
							{{ identifier }}
							<div class="small-margin-top">
								<div v-for="(template, locale_id) in templates" class="flex align-items">
									<Flag :localeid="locale_id" />
									<div style="margin-left: 7px;">{{ template.subject }}</div>
								</div>
							</div>
						</td>
						<td v-for="locale in getLocales">

							<template v-if="templates[locale.id]">
								<button :disabled="saving" class="small" v-on:click="editTemplate(templates[locale.id].id)">Edit</button>
							</template>
							<template v-else>
								<button :disabled="saving" class="small" v-on:click="createTemplate(identifier, locale.id)">Create</button>
							</template>

						</td>
					</tr>
				</tbody>
			</table>

		</div>
	</div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

export default {
  data: () => ({
    loading: false,
    saving: false,
    records: [],
    example_ids: {},
    examples: {},
    edit_template: false,
    variable_names: {}
  }),
  computed: {
    ...mapGetters([
      'getLocales'
    ]),
    getVariabeNames () {
      return this.variable_names[this.edit_template.id]
    },
    getVariables () {
      var text = this.edit_template.message
      var matches = text.match(/{{\s?[a-zA-Z\._]+\s?}}/g)
      if (matches == null) {
        matches = text.match(/{{\s?\$[a-zA-Z\._\[\]'']+\s?}}/g)
      }
      var result = {}

      for (var i in matches) {
        var match = matches[i]
        var variable = match.replace(/({{\s?|\s?}}|\.[a-zA-Z_]+)/g, '').trim()
        if (match.match(/{{\s?\$[a-zA-Z\._\[\]'']+\s?}}/g)) {
          variable = match.replace(/({{\s?|\s?}}|\$|\['[a-zA-Z\._\[\]'']+'\])/g, '').trim()
        }

        result[variable] = {
          variable: variable,
          class: this.getClassName(variable)
        }

        // if (!this.example_ids[variable]) {
        //   this.example_ids[variable] = this.getExampleId(variable)
        // }
      }

      return result
    }
  },
  methods: {
    setVariable (variable) {
      if (!this.example_ids[variable]) {
        this.example_ids[variable] = this.getExampleId(variable)
      }
    },
    insertKey (variable, key) {
      var el = this.$refs.textarea
      var newText = '{{ ' + variable + '.' + key + ' }}'

      const [start, end] = [el.selectionStart, el.selectionEnd]

  				el.setRangeText(newText, start, end, 'select')
    },
    getRequestVariables () {
      var result = {}

      for (var v in this.getVariables) {
        result[v] = {
          class: this.getVariables[v].class,
          id: this.example_ids[v]
        }
      }

      return result
    },
    sendExampleToMe () {
      Vue.$api.post('/email-template/preview', {
        variables: this.getRequestVariables(),
        template: this.edit_template
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          alert('Example sent')
        }
      })
    },
    getExampleId (variable) {
      return this.examples[variable] ? this.examples[variable] : 1
    },
    getClassName (variable) {
      switch (variable) {
        case 'order':
          return 'App\\Interfaces\\Objects\\Order\\IOrder'
        case 'customer':
          return 'App\\Interfaces\\Objects\\Customer\\ICustomer'
        case 'user':
          return 'App\\Interfaces\\Objects\\User\\IUser'
        case 'payment':
          return 'App\\Interfaces\\Objects\\Payment\\IScheduledPayment'
        case 'request':
          return 'App\\Interfaces\\Objects\\Exchange\\IExchangeRequest'
        case 'call':
          return 'App\\Interfaces\\Objects\\Customer\\IScheduledCall'
        case 'reset':
          return 'App\\Interfaces\\Objects\\User\\IPasswordReset'
      }
    },
    update () {
      Vue.$api.patch('/email-template/' + this.edit_template.id, this.edit_template, {
        loader: toggle => this.saving = toggle,
        callback: data => {
          this.edit_template = false

          this.load()
        }
      })
    },
    afterCreated (data) {
      this.load()
    },
    createTemplate (identifier, localeId) {
      Vue.$api.post('/email-template', {
        identifier: identifier,
        localeId: localeId
      }, {
        loader: toggle => this.saving = toggle,
        callback: data => this.afterCreated(data)
      })
    },
    editTemplate (id) {
      for (var i in this.records) {
        var templates = this.records[i]

        for (var t in templates) {
          var template = templates[t]

          if (template.id == id) {
            this.edit_template = template
          }
        }
      }
    },
    load () {
      Vue.$api.get('/email-templates', {}, {
        before: () => this.loading = true,
        always: () => this.loading = false,
        callback: data => this.parse(data)
      })
    },
    parse (data) {
      this.records = data.list
      this.examples = data.examples
      this.variable_names = data.variables
    }
  },
  created () {
    this.load()
  }
}
</script>
